<template>
  <div class="seccion404 404">

    <section id="servicios" class="secciones seccion-blanca">        
       <div class="container">
        <h1>Error 404. Oops! Estas perdido.</h1>
        <div class="row">
         <div class="col-md-12">
           <p style="text-align: center;">La pagina que estas buscando no se encuentra.</p>
         </div>
        </div>
       </div>
    </section>

    <TwoModules></TwoModules>
    <Instagram></Instagram>

  </div>

</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Instagram from "@/components/products/Instagram.vue";
import _ from "lodash";
import { errorToaster } from '@/components/shared/service/ErrorHandler';

export default {
  components: { TwoModules,
    Instagram },
  methods: {
    scroll_inicio(){
      window.scrollTo(0,0);
    },
  },
  created() {
    this.scroll_inicio();
  }
};
</script>

<style lang="scss" src="./404.scss"></style>
